import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, OnInit, ViewChild } from '@angular/core';
import { Network } from 'vis-network';

@Component({
  selector: 'app-dependency-dashboard',
  templateUrl: './dependency-dashboard.component.html',
  styleUrls: ['./dependency-dashboard.component.css']
})
export class DependencyDashboardComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('visNetwork', { static: false }) visNetwork!: ElementRef;
  private networkInstance: any;

  @Input() nodes = [];
  @Input() edges = [];
  @Input() type = '';

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    const data = { nodes: changes.nodes.currentValue, edges: changes.edges.currentValue };
    if (this.networkInstance !== undefined)
      this.networkInstance.setData(data)
  }

  ngAfterViewInit(): void {
    const data = {};

    const container = this.visNetwork;
    this.networkInstance = new Network(container.nativeElement, data,
      {
        interaction: {
          navigationButtons: true,
          keyboard: true
        },
        layout: {
          improvedLayout: false
        },
        physics: {
          stabilization: {
            enabled: true,
            iterations: 1,
            updateInterval: 1000
          },
          solver: 'repulsion'
        },
        edges: {
          color: '#d1cfcf'
        },
        nodes: {
          shape: "dot",
          scaling: {
            customScalingFunction(min, max, total, value) {
              return value / total;
            },
            min: 5,
            max: 150,
          },
        },
        height: '660px',
      });
  }
}
